import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { SupportDialog } from "@/components/SupportDialog";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function SupportTab() {
  const { t, i18n } = useTranslation(["pages.settings"]);
  const appVersion =
    import.meta.env.VITE_APP_VERSION?.trim() ||
    t("pages.settings:sections.support.systemInfo.lastUpdateUnavailable");

  const lastUpdatedLabel = useMemo(() => {
    const buildDateSource =
      import.meta.env.VITE_APP_BUILD_DATE || document.lastModified;
    const parsedDate = new Date(buildDateSource);

    if (Number.isNaN(parsedDate.getTime())) {
      return t("pages.settings:sections.support.systemInfo.lastUpdateUnavailable");
    }

    return new Intl.DateTimeFormat(i18n.language, {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(parsedDate);
  }, [i18n.language, t]);

  return (
    <div className="flex flex-1 min-h-[420px] gap-6">
      {/* Left column - Messages */}
      <div className="w-1/2 flex flex-col min-h-0">
          <SupportDialog open={true} onOpenChange={() => {}} embedded={true} />
      </div>

      {/* Right column - System information */}
      <div className="w-1/2 overflow-y-auto">
        <div className="space-y-6">
          <Card>
            <CardContent className="p-3 space-y-2">
              <h3 className="text-xs font-medium text-slate-900 mb-2 uppercase tracking-wider">
                {t("pages.settings:sections.support.systemInfo.title")}
              </h3>
              <div className="flex justify-between">
                <span className="text-xs text-slate-700">
                  {t("pages.settings:sections.support.systemInfo.version")}
                </span>
                <span className="text-xs font-medium">{appVersion}</span>
              </div>
              <Separator />
              <div className="flex justify-between">
                <span className="text-xs text-slate-700">
                  {t("pages.settings:sections.support.systemInfo.lastUpdate")}
                </span>
                <span className="text-xs font-medium">{lastUpdatedLabel}</span>
              </div>
              <Separator />
              <div className="flex justify-between">
                <span className="text-xs text-slate-700">
                  {t("pages.settings:sections.support.systemInfo.status")}
                </span>
                <div className="flex items-center gap-1">
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                  <span className="text-xs font-medium text-green-600">
                    {t("pages.settings:sections.support.systemInfo.active")}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
